import React from "react";
import SEOLandingPage from "./SEOLandingPage";

const DeveloperToolsAndroid: React.FC = () => (
  <SEOLandingPage
    title="Developer Tools for Android — All-in-One Dev Toolkit on Mobile | Cosmovex"
    metaDescription="Regex tester, Base64, JWT decoder, hash generator, color picker, code snippets — all offline. DevBuddy is the developer toolkit for Android. Free on Google Play."
    ogTitle="Developer Tools for Android — DevBuddy"
    h1="Developer Tools for Android"
    intro="One app with every developer utility you reach for daily: regex tester, Base64 encoder, JWT decoder, hash generators, color picker, and more. DevBuddy puts an all-in-one developer toolkit in your pocket, fully offline."
    paragraphs={[
      "Developers constantly switch between small utilities — encoding a string to Base64, testing a regex pattern, decoding a JWT to check its claims, converting a hex color to RGB. DevBuddy brings all of these into a single Android app so you're not juggling browser tabs or hunting for a reliable online tool every time you need something basic.",
      "The regex tester is interactive: type your pattern and test string, and matches highlight in real time. You can toggle flags (case-insensitive, multiline, dotAll), see capture groups labeled separately, and copy the match results. It's the same experience as regex101.com but on your phone without an internet connection.",
      "JWT decoding is immediate — paste a token and DevBuddy splits it into header, payload, and signature. The payload JSON is formatted and displayed with expiry times converted to human-readable dates. This is useful when debugging auth issues on a mobile API or checking token claims from a test environment.",
      "Hash generators cover MD5, SHA-1, SHA-256, and SHA-512. Base64 encoding and decoding handles both standard and URL-safe variants. The color picker converts between HEX, RGB, HSL, and HSV with a visual color wheel. Every tool is reachable from the home screen in one tap, with no ads interrupting the workflow.",
    ]}
    features={[
      "Interactive regex tester with real-time match highlighting",
      "Base64 encoder and decoder (standard and URL-safe)",
      "JWT decoder showing header, payload, and expiry",
      "Hash generator: MD5, SHA-1, SHA-256, SHA-512",
      "Color picker with HEX, RGB, HSL, and HSV conversion",
      "URL encoder and decoder",
      "Unix timestamp converter to human-readable dates",
      "Code snippet library for common patterns and boilerplate",
      "Works fully offline — no internet connection required",
      "Clean one-tap access to all tools from home screen",
    ]}
    playStoreUrl="https://play.google.com/store/apps/details?id=com.cosmovex.devbuddy"
    icon="/images/devbuddy.png"
    appName="DevBuddy"
    accentColor="#A8720E"
    canonicalPath="/developer-tools-android"
  />
);

export default DeveloperToolsAndroid;
